<template>
  <AnnDialog
    :model-value="props.modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
  >
    <div class="ann-power-contributed">
      <img
        class="ann-power-contributed-bg"
        :src="backgroundImg"
        alt=""
        aria-hidden="true"
      />
      <img
        class="ann-power-contributed-decor"
        :src="decorImg"
        alt=""
        aria-hidden="true"
      />
      <p class="ann-power-contributed-text">
        {{ t('ann2026.powerContributed.text', { count: props.count }) }}
      </p>
      <AnnDialogClose
        :aria-label="t('ann2026.dialog.close')"
        @close="emit('update:modelValue', false)"
      />
    </div>
  </AnnDialog>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import AnnDialog from '../AnnDialog/index.vue'
import AnnDialogClose from '../AnnDialogClose/index.vue'
import backgroundImg from '@/assets/imgs/act/ann2026/popups/power-contributed/background.png'
import decorImg from '@/assets/imgs/act/ann2026/popups/power-contributed/candle.png'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  count: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['update:modelValue'])

const { t } = useI18n({ useScope: 'global' })
</script>

<style lang="less" scoped>
.ann-power-contributed {
  --ann-close-top: -12px;
  --ann-close-right: -18px;

  position: relative;
  width: 703px;
  height: 239px;
  overflow: visible;
}

.ann-power-contributed-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 703px;
  height: 239px;
  pointer-events: none;
}

.ann-power-contributed-decor {
  position: absolute;
  top: 42px;
  left: 5px;
  z-index: 2;
  width: 45px;
  height: 155px;
  pointer-events: none;
}

.ann-power-contributed-text {
  position: absolute;
  top: 111px;
  left: 56px;
  z-index: 2;
  width: 590px;
  height: 44px;
  margin: 0;
  color: #fff;
  font-size: 34px;
  line-height: 44px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
}
</style>
